module.exports = __webpack_public_path__ + "media/images/story/typo/greetingsNatural-2c5e32cdf23308b19eb663d7c72a36a2.svg";